<template>
    <div v-if="isVehicleDetails" class="header__btns">
        <router-link
            v-if="!isFirstVehicleInList()"
            class="header-carDetail__btn header-carDetail__btn_prev"
            :to="{ path: navPath('previous') }"
        >
            <svg class="sprite-icon fc-icon-chevron-left">
                <use xlink:href="/img/sprite.svg#chevron-left"></use>
            </svg>
            <div class="custom-button-text">
                {{ i18n.t("header.prevCar") }}
            </div>
        </router-link>
        <div v-else class="custom-button custom-button-left">
            <div class="custom-button-text">{{ i18n.t("header.prevCar") }}</div>
        </div>
        <router-link
            v-if="!isLastVehicleInList()"
            class="header-carDetail__btn header-carDetail__btn_next"
            :to="{ path: navPath('next') }"
        >
            <div class="custom-button-text" style="margin-left: 5px">
                {{ i18n.t("header.nextCar") }}
            </div>
            <svg class="sprite-icon fc-icon-chevron-right" style="vertical-align: middle">
                <use xlink:href="/img/sprite.svg#chevron-right"></use>
            </svg>
        </router-link>
        <div v-else class="custom-button custom-button-right">
            <div class="custom-button-text">{{ i18n.t("header.nextCar") }}</div>
        </div>
    </div>
</template>

<script lang="ts">
import { Prop, Vue } from "vue-property-decorator";
import { setup } from "vue-class-component";
import { useI18n } from "@/shared/composables/use-i18n";

export default class NavigationButtons extends Vue {
    @Prop({ required: true }) readonly isVehicleDetails!: boolean;
    @Prop({ type: Function, required: true }) readonly navigateToVehicle!: (
        direction: "previous" | "next",
    ) => string;
    @Prop({ type: Function, required: true })
    readonly isFirstVehicleInList!: () => boolean;
    @Prop({ type: Function, required: true })
    readonly isLastVehicleInList!: () => boolean;
    navPath(direction: "previous" | "next") {
        return `/auth/vehicle-details/${this.navigateToVehicle(direction)}`;
    }
    i18n = setup(useI18n);
}
</script>

<style scoped lang="scss">
@import "../../../shared/styles/vars";
.header-carDetail__btn.header-carDetail__btn_prev {
    display: flex;
    align-items: center;
    padding: 5px;
    height: 25px;
    margin-top: -2px;
    font-size: 10px;
    width: 77px;
    border: 1px rgba(98, 118, 144, 0.3);
}

.header-carDetail__btn.header-carDetail__btn_next {
    display: flex;
    align-items: center;
    padding: 5px;
    height: 25px;
    margin-top: -2px;
    font-size: 10px;
    width: 77px;
    border: 1px rgba(98, 118, 144, 0.3);
}

@media (max-width: 768px) {
    .header-carDetail__btn.header-carDetail__btn_prev {
        padding: 0;
        margin: 0;
    }

    .header-carDetail__btn.header-carDetail__btn_next {
        padding: 0;
        margin: 0;
    }
}
.sprite-icon.fc-icon-chevron-right {
    fill: #627690;
    stroke: #627690;
    height: 16px;
}
.sprite-icon.fc-icon-chevron-left {
    fill: #627690;
    stroke: #627690;
    height: 16px;
}

.button--hidden-prefix {
    .letter {
        opacity: 0;
        transform: scale(0);
        max-width: 0;
        display: inline-block;
    }

    &:hover {
        .letter {
            animation: hoverButton 0.5s ease-out calc(0.02s * var(--i));
            animation-fill-mode: forwards;
        }
    }
    &:not(:hover) {
        .letter {
            animation: notHoverButton calc(0.5s / var(--i)) ease-out calc(0.2s / var(--i));
            animation-fill-mode: backwards;
        }
    }
}

@keyframes hoverButton {
    0% {
        opacity: 0;
        transform: scale(0);
        max-width: 0;
    }
    100% {
        opacity: 1;
        transform: scale(1);
        max-width: 20px;
    }
}
@keyframes notHoverButton {
    0% {
        opacity: 1;
        transform: scale(1);
        max-width: 20px;
    }
    100% {
        opacity: 0;
        transform: scale(0);
        max-width: 0;
    }
}

.custom-button {
    display: flex;
    align-items: center;
    padding: 5px;
    height: 25px;
    margin-top: -2px;
    font-size: 10px;
    width: 77px;
    border: 1px solid rgba(98, 118, 144, 0.3);
    margin-left: 1em;
    cursor: pointer;
    justify-content: center;
}

.custom-button-text {
    color: $color-text-gray;
    font-size: 11px;
    font-weight: 500;
    word-wrap: break-word;
}

.header__btns {
    display: flex;
    position: relative;
    font-family: var(--font-family);
}
.custom-button-left {
    margin-left: 5px;
}
.custom-button-right {
    margin-left: 10px;
}
@media (max-width: 1279px) {
    .header__btns {
        margin-left: 0;
        gap: 5px;
        padding-left: 5px;
        padding-right: 5px;
    }
    .custom-button {
        margin-top: 0;
    }
    .custom-button,
    .header-carDetail__btn_prev,
    .header-carDetail__btn_next {
        flex-grow: 1;
        justify-content: center;
    }
    .custom-button-right {
        margin-left: 0px;
    }
}
</style>
